'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.span.withConfig({
  componentId: 'nf4chz-0'
})(['', ' ', ' ', ' ', ' ', ' ', ''], function (p) {
  return (p.class === 'description-before' || p.class === 'description-after') && '\n    display: block;\n  ';
}, function (p) {
  return p.class === 'description-before' && '\n    margin-bottom: calc(' + p.theme.spacingUnit + ' / 2);\n    line-height: 1.5;\n  ';
}, function (p) {
  return p.class === 'description-after' && '\n    font-size: 0.8em;\n    margin-top: 0;\n    padding-bottom: calc(' + p.theme.spacingUnit + ' / 2);\n    line-height: 1.2em;\n    clear: both;\n  \n    ' + (p.labelDisplay === 'inline' && '\n      @media (min-width: 768px) {\n        padding-left: calc(' + p.theme.spacingUnit + ' / 2);\n        margin-left: ' + p.theme.inlineLabelWidth + ';\n        float: left;\n      }\n    ') + '\n  ';
}, function (p) {
  return (p.value === 'field-prefix' || p.value === 'field-suffix') && '\n    display: inline-block;\n  ';
}, function (p) {
  return p.value === 'field-prefix' && '\n    margin-right: 5px;\n  ';
}, function (p) {
  return p.value === 'field-suffix' && '\n    margin-left: 5px;\n  ';
});